import {
  lightReviewFragment,
  reviewFragment,
} from '@/services/fragments/reviewFragment'

export const getReviewQuery = /* GraphQL */ `
  query GetReview($id: ID!) {
    getReview(id: $id) {
      ...fullReviewData
    }
  }
  ${reviewFragment}
`

export const PendingReviewsCountQuery = /* GraphQL */ `
  query PendingReviewsCount(
    $organizationID: ID!
    $filter: ModelReviewFilterInput
    $limit: Int
    $nextToken: String
  ) {
    reviewsByOrganization(
      organizationID: $organizationID
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: DESC
    ) {
      items {
        id
        status
        elementID
      }
      nextToken
    }
  }
`

export const lightReviewsByOrganizationQuery = /* GraphQL */ `
  query LightReviewsByOrganization(
    $organizationID: ID!
    $filter: ModelReviewFilterInput
    $limit: Int
    $nextToken: String
  ) {
    reviewsByOrganization(
      organizationID: $organizationID
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: DESC
    ) {
      items {
        ...lightReviewData
      }
      nextToken
    }
  }
  ${lightReviewFragment}
`
export const reviewsByOrganizationQuery = /* GraphQL */ `
  query ReviewsByOrganization(
    $organizationID: ID!
    $filter: ModelReviewFilterInput
    $limit: Int
    $nextToken: String
  ) {
    reviewsByOrganization(
      organizationID: $organizationID
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: DESC
    ) {
      items {
        ...fullReviewData
      }
      nextToken
    }
  }
  ${reviewFragment}
`
